import React, { useEffect, useRef, useState } from "react";
import {
    Button,
    TextField,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle
} from "@material-ui/core";
import TextEditor from "../Frequents/TextEditor.js";
import API from "../../actions";
import moment from "moment";
import html2pdf from "html2pdf.js";
import logo from "../../img/logoNoText.png";
import axios from "axios";

export default props => {
    const [open, setOpen] = useState(false);
    const [recipients, setRecipients] = useState("");
    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");
    const invoiceRef = useRef();
    const [inv, setInv] = useState(null);
    useEffect(() => {
        (async () => {
            const img = await API.getInvoice(props.id);
            const data = JSON.parse(img.image);
            setInv(data);
        })();
    }, [props.id]);
    const handleClose = () => {
        setOpen(false);
        setRecipients("");
        setTitle("");
        setDescription("");
    };

    const getInvoiceNumber = data => {
        let invoiceNumber =
            "" +
            (data?.number !== undefined
                ? data?.number
                : data?.company
                ? data?.company?.invoiceCount
                : data?.therapist?.invoiceCount);

        if (invoiceNumber.length < 4) {
            invoiceNumber = "0" + invoiceNumber;
        }
        return invoiceNumber;
    };

    const comma = n => {
        const a = Math.floor(n);
        const b = Math.floor(10 * (n - a));
        const c = Math.floor(100 * (n - a)) - 10 * b;
        return a + "," + b + "" + c;
    };

    const getField = (name, prop) => {
        let l = "";
        prop.forEach(field => {
            if (field.name === name) l = field.value;
        });
        return l;
    };

    const getCompanyInfo = (data, key) => {
        if (!data) return "";
        const { company, therapist } = data;
        // return company info
        return company ? company[key] : therapist[key];
    };
    const token = localStorage.getItem("token");
    const handleDownload = async () => {
        const element = invoiceRef.current;

        if (!element) {
            console.error("Element not found!");
            return;
        }
        const opt = {
            margin: 0,
            filename: "FAKTURA.pdf",
            image: { type: "jpeg", quality: 0.98 },
            html2canvas: { scale: 2 },
            jsPDF: { unit: "in", format: "a4", orientation: "portrait" }
        };

        try {
            // Generate PDF and get the blob
            const worker = html2pdf().set(opt).from(element).toPdf();
            const blob = await worker.output("blob");

            // Create FormData and append the blob
            const formData = new FormData();
            formData.append("action", "invoiceMail");
            formData.append("token", token);
            formData.append("to", recipients);
            formData.append("subject", title);
            formData.append("message", description);
            formData.append("invoice", blob, "invoice.pdf");
            formData.append("description", description);
            formData.append("filename", "Faktura.pdf");

            const url =
                window.location.hostname === "localhost"
                    ? "http://localhost:3001"
                    : window.location.href.substring(0, window.location.href.split("?")[0].lastIndexOf("/"));

            let config = {
                method: "post",
                maxBodyLength: Infinity,
                url: `${url}/api/HandsOnBookingAPI`,
                headers: {
                    headers: { "content-type": "multipart/form-data" }
                },
                data: formData
            };
            handleClose();

            return await axios
                .request(config)
                .then(response => {
                    return response.data;
                })
                .catch(error => {
                    console.log(error);
                    throw error.response.data;
                });
        } catch (error) {
            console.error("PDF generation or upload failed:", error);
        }
    };

    useEffect(() => {
        if (invoiceRef.current) {
            handleDownload();
        }
    }, [inv, invoiceRef]);

    const renderHtmlInvoice = (
        <div style={{ padding: "20px", display: "none" }}>
            <div ref={invoiceRef} className="invoice-container">
                <div className="header">
                    <img src={inv?.company ? inv?.company?.logo || logo : inv?.therapist?.logo || logo} alt="Logo" />
                    <h2>{inv?.company ? inv?.company?.companyName : inv?.therapist?.companyName}</h2>
                </div>

                <div className="info">
                    <div>
                        <p>
                            {inv?.client?.nameFirst} {inv?.client?.nameLast}
                            <br />
                            {inv?.client?.address}
                            <br />
                            {inv?.client?.post} {inv?.client?.town}
                            <br />
                            CPR: {inv?.client?.CPR?.substring(0, 6)} - {inv?.client?.CPR?.substring(6)}
                        </p>
                    </div>
                    <div>
                        <p>
                            Fakturanr.: {getInvoiceNumber(inv)}
                            <br />
                            Dato:{moment(Number(inv?.booking?.from)).format("DD/MM/YYYY")}
                        </p>
                    </div>
                </div>

                <div className="title"> {inv?.settings?.type ? "Faktura" : "Kreditnota"}</div>
                <div className="date-line">
                    Du blev d. {moment(Number(inv?.booking?.from)).format("DD/MM/YYYY")} kl.{" "}
                    {moment(Number(inv?.booking?.from)).format("HH:mm")} behandlet af {inv?.therapist?.nameFirst}{" "}
                    {inv?.therapist?.nameLast}.
                </div>

                <table className="sendInvoiceTable">
                    <thead>
                        <tr>
                            <th>Behandling</th>
                            <th>Varighed</th>
                            <th>Pris</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>{inv?.treatment?.name}</td>
                            <td>{inv?.treatment?.duration / 60} min</td>
                            <td> {comma(inv?.treatment?.price)} DKK</td>
                        </tr>
                    </tbody>
                </table>

                <table className="summary sendInvoiceTable">
                    <tbody>
                        {inv?.settings?.discount && (
                            <tr>
                                <td>Rabat:</td>
                                <td> {comma(inv?.settings?.discount)} DKK</td>
                            </tr>
                        )}

                        {inv?.settings?.moms && (
                            <tr>
                                <td>Moms 25%:</td>
                                <td>{comma((inv?.treatment?.price - (inv?.settings?.discount || 0)) * 0.25)} DKK</td>
                            </tr>
                        )}
                        <tr>
                            <td className="highlight">I alt:</td>
                            <td className="highlight">
                                {comma(
                                    inv?.treatment?.price -
                                        (inv?.settings?.discount || 0) +
                                        (inv?.settings?.moms
                                            ? (inv?.treatment?.price - (inv?.settings?.discount || 0)) * 0.25
                                            : 0)
                                )}{" "}
                                DKK
                            </td>
                        </tr>
                    </tbody>
                </table>

                <div style={{ clear: "both" }}></div>

                {inv?.settings?.aktuelBehandling !== false &&
                    (inv?.journal ? (
                        <ul style={{ marginTop: 20 }}>
                            <li>Aktuel behandling</li>
                            {inv?.journal?.treatment && <li>{inv?.journal?.treatment}</li>}
                        </ul>
                    ) : (
                        <ul style={{ marginTop: 20 }}>
                            <li>Aktuel behandling</li>
                            {inv?.stamJournal?.length > 0 && <li>{getField("Aktuel behandling", inv?.stamJournal)}</li>}
                        </ul>
                    ))}

                {inv?.settings?.followUpText &&
                    (inv.journal ? (
                        <ul style={{ marginTop: 20 }}>
                            <li>Opfølgende behandling</li>
                            {inv?.journal?.followUp && <li>{inv?.journal?.followUp}</li>}
                        </ul>
                    ) : (
                        <ul style={{ marginTop: 20 }}>
                            <li>Opfølgende behandling</li>
                            {inv?.stamJournal?.length > 0 && (
                                <li>{getField("Opfølgende behandling", inv?.stamJournal)}</li>
                            )}
                        </ul>
                    ))}
                <div className="footer-notes">Betaling efter afsluttet behandling, hvis ikke andet er aftalt.</div>

                <div className="payment-info">
                    <div>MobilePay: {getCompanyInfo(inv, "mobilePay") ?? getCompanyInfo(inv, "mobilePay")} </div>
                    <div>Bankreg: {getCompanyInfo(inv, "regNumber") ?? getCompanyInfo(inv, "regNumber")}</div>
                    <div>Kontonr: {getCompanyInfo(inv, "accountNumber") ?? getCompanyInfo(inv, "accountNumber")}</div>
                </div>

                <div className="bottom-footer">
                    {getCompanyInfo(inv, "companyName")}, {getCompanyInfo(inv, "address")},{" "}
                    {getCompanyInfo(inv, "zipCode")} {getCompanyInfo(inv, "town")}
                    <br />
                    CVR: {getCompanyInfo(inv, "CVR").trim()} - {getCompanyInfo(inv, "email")} -{" "}
                    {getCompanyInfo(inv, "phone")}
                </div>
            </div>
        </div>
    );

    return (
        <div>
            {inv !== null ? renderHtmlInvoice : ""}
            <Button
                onClick={async () => {
                    const inv = await API.getInvoice(props.id);
                    if (inv.image[0] !== "{") return;
                    const img = JSON.parse(inv.image);
                    setRecipients(img.client.email);
                    setOpen(true);
                }}
                size="small">
                Send til Mail
            </Button>
            <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title" maxWidth="lg">
                <DialogTitle id="form-dialog-title">Send faktura</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Fakturaen sendes som en vedhæftet fil i mail til alle udvalgte modtagere.
                    </DialogContentText>
                    <TextField
                        autoFocus
                        margin="dense"
                        id="topic"
                        label="Modtagere (separer med komma)"
                        type="text"
                        fullWidth
                        value={recipients}
                        onChange={event => setRecipients(event.target.value)}
                    />
                    <TextField
                        autoFocus
                        margin="dense"
                        id="topic"
                        label="Emnefelt"
                        type="text"
                        fullWidth
                        value={title}
                        onChange={event => setTitle(event.target.value)}
                    />
                    <TextEditor value={description} onChange={setDescription} />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        Luk
                    </Button>
                    <Button
                        onClick={async () => {
                            if (!window.confirm("Er du sikker?")) return;
                            handleDownload();
                        }}
                        color="primary">
                        Send
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};
